
// --
// Pinterest SHARE
// --
// class that shares shareurl via Pinterest dialog
//

// --
// USAGE
// --
//
// data-component="share-pinterest" data-component-options='{"shareURL":"[url-to-share]"}'
//
// "shareURL" is the site url to share ie http://uniondigital.co.nz
//


import Component_share_base from './_share-base'

export default class Component_share_pinterest extends Component_share_base {

  constructor(el, options) {

    var imageURL = $("head").find("meta[property='og:image']").attr("content");
    var pageDescription = $("head").find("meta[property='og:description']").attr("content");
    // var imageURL = typeof options.image !== "undefined" ? options.image : $("head").find("meta[property='og:image']").attr("content");
    // var pageDescription = typeof options.description !== "undefined" ? options.description : $("head").find("meta[property='og:description']").attr("content");
    if(!imageURL)
    {
        console.log("No image passed in and could not find og image tag");
        return;
    }

    if(!pageDescription)
    {
        console.log("No description passed in and could not find og page description tag");
        return;
    }

    super(el, $.extend(true, {

// <a href="http://www.pinterest.com/pin/create/button/?url={url_encoded_url}&amp;media={url_encoded_image_url}&amp;description={url_encoded_description}">Pin It</a>


      'windowTarget':'http://www.pinterest.com/pin/create/button/?media='+imageURL+'&amp;description='+pageDescription+'&url=',
      'windowName':'Pinterest',
      'windowParams':'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'

    }, options), 'component');

  }


  // overload base trigerShare function
  //combine share text with share url if share url isn't false
  
  triggerShare(event){

    this.readLatestElementOptions();

    event.preventDefault();

    var textToShare = "";

    if(typeof this.options.shareText !== "undefined")
    {
      textToShare = this.options.shareText;
    }

    if(this.options.shareURL)
    {
      if(textToShare)
      {
        textToShare += " ";
      }
      textToShare +=  this.options.shareURL;
    }

    this.openSharePopup(textToShare,this.options.windowTarget,this.options.windowName,this.options.windowParams);

  }


}





/** WEBPACK FOOTER **
 ** ./components/share-pinterest.js
 **/